import { supportsPassiveEvents } from 'detect-it';

export const passiveArg = supportsPassiveEvents ? { passive: true } : false;
export const activeArg = supportsPassiveEvents ? { passive: false } : true;
export const getWindowSize = () => {
  if (typeof window === 'object') {
    return [
      window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth,
      window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight
    ];
  } else {
    return [null, null];
  }
};

export const isTouchDevice = () => {
  if (typeof window !== 'object') return false;
  return (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
};

export const getByString = (path, obj, separator = '.') => {
  const properties = path.split(separator);
  return properties.reduce((prev, curr) => prev && prev[curr], obj);
};

export const getImage = img => {
  if (img?.src?.childImageSharp?.fixed) {
    return { ...img.src.childImageSharp.fixed };
  } else if (img?.src?.childImageSharp?.gatsbyImageData) {
    return { ...img.src.childImageSharp.gatsbyImageData, src: img.url };
  } else {
    return {
      src: img?.url || '',
      images: { sources: [], fallback: { src: img?.url || '' } }
    };
  }
};

export const externalLink = {
  target: '_blank',
  rel: 'noreferrer'
};
